// QuickActionsRowV3 — 3 CTA cards: search lead, new campaign, ai compose.
import React from "react";
import { useTranslation } from "react-i18next";
import { Search, Send, Sparkles } from "lucide-react";
import QuickActionCardV3 from "../components/QuickActionCardV3";

export default function QuickActionsRowV3() {
    const { t } = useTranslation("dashboard_v3");

    const items = [
        {
            testId: "dashboard-v3-quick-lead",
            title: t("quick_actions.search_lead_title"),
            subtitle: t("quick_actions.search_lead_sub"),
            href: "/leads",
            icon: Search,
            gradientFrom: "#FFFFFF",
            gradientTo: "#A3A3A3",
        },
        {
            testId: "dashboard-v3-quick-campaign",
            title: t("quick_actions.new_campaign_title"),
            subtitle: t("quick_actions.new_campaign_sub"),
            href: "/outreach/campaigns/new",
            icon: Send,
            gradientFrom: "#E5E5E5",
            gradientTo: "#737373",
        },
        {
            testId: "dashboard-v3-quick-compose",
            title: t("quick_actions.ai_compose_title"),
            subtitle: t("quick_actions.ai_compose_sub"),
            href: "/outreach",
            icon: Sparkles,
            gradientFrom: "#CCCCCC",
            gradientTo: "#525252",
        },
    ];

    return (
        <section aria-labelledby="quick-actions-heading" className="mt-8">
            <h2
                id="quick-actions-heading"
                className="text-[11px] uppercase tracking-widest text-[#CCCCCC] font-semibold mb-3"
            >
                {t("quick_actions.headline")}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {items.map((it, i) => (
                    <QuickActionCardV3 key={it.testId} {...it} delay={i * 0.05} />
                ))}
            </div>
        </section>
    );
}
